var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaLinealAbajo24X4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 40,
    viewBox: "0 0 25 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5864 28.1999C19.3164 27.8899 18.8464 27.8499 18.5264 28.1199L12.7664 33.0599V5.68994C12.7664 5.27994 12.4264 4.93994 12.0164 4.93994C11.6064 4.93994 11.2664 5.27994 11.2664 5.68994V33.0599L5.50642 28.1199C5.19642 27.8499 4.71642 27.8899 4.44642 28.1999C4.17642 28.5099 4.21642 28.9899 4.52642 29.2599L10.7464 34.5899C11.1164 34.9099 11.5664 35.0599 12.0164 35.0599C12.4664 35.0599 12.9164 34.8999 13.2864 34.5899L19.5064 29.2599C19.8164 28.9899 19.8564 28.5199 19.5864 28.1999Z",
    fill: "#88919E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaLinealAbajo24X4);
export default __webpack_public_path__ + "static/media/FLECHA_LINEAL_ABAJO_24X4.ac3c758d5e63cf41a5abbcefbddb96ca.svg";
export { ForwardRef as ReactComponent };